import React, { useState, useEffect } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'

function PaymentDialog({
  open,
  onClose,
  data: dataProp,
  setReturnValue,
  title,
  defaultTitle = 'Paiement',
  FormComponent,
  ...other
}) {
  const [data, setData] = useState(dataProp)
  const [checkForm, setCheckForm] = useState(false)

  useEffect(() => {
    setData(dataProp)
  }, [dataProp])

  const handleCancel = () => onClose(null)
  const handleValidSubmit = () => onClose(data)

  return (
    <Dialog open={open} maxWidth='xs' sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }} {...other}>
      <DialogTitle>{title || defaultTitle}</DialogTitle>
      <DialogContent dividers>
        <FormComponent
          modeProps='dialog'
          checkForm={checkForm}
          setCheckForm={setCheckForm}
          value={data}
          setReturnValue={setData}
          onValidSubmit={handleValidSubmit}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Annuler</Button>
        <Button onClick={() => setCheckForm(true)}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default PaymentDialog
